import { URLPattern } from 'urlpattern-polyfill'
import { CreateHistory, utility } from 'rutter'

export const { buildURL } = utility

export enum ROUTE_NAMES {
  LOGIN = 'login',
  INDEX = 'index',

  TENANT_STATISTICS = 'statistics',

  APPS = 'apps',
  CREATE_APP = 'create',
  APP_HOME = 'app-home',
  APP_BASIC_SETTING = 'app-basic-setting',
  APP_ADVANCED_SETTING = 'app_advance_setting',
  APP_WEBHOOK_SETTING = 'app_webhook_setting',
  APP_LAUNCHPAD_SETTING = 'app_launchpad_setting',
  APP_GROUPS = 'app_groups',
  APP_GROUP_DETAIL = 'app_group_detail',
  APP_GROUP_CREATE = 'app_group_create',
  APP_GROUP_EDIT = 'app_group_edit',
  APP_ROLES = 'app_roles',
  APP_ROLE_DETAIL = 'app_role_detail',
  APP_ROLES_CSV_IMPORT = 'app_roles_csv_import',
  APP_ROLE_CREATE = 'app_role_create',
  APP_ROLE_EDIT = 'app_role_edit',
  APP_USERS = 'app_users',
  APP_USER_DETAIL = 'app_user_detail',
  APP_USERS_CSV_IMPORT = 'app_users_csv_import',
  USER_ASSIGN_ROLES = 'user_assign_roles',
  UPDATE_PASSWORD = 'update_password',
  APP_PERMISSIONS = 'app_permissions',
  APP_PERMISSION_DETAIL = 'app_permission_detail',
  APP_PERMISSIONS_CSV_IMPORT = 'app_permissions_csv_import',
  APP_PERMISSION_CREATE = 'app_permission_create',
  APP_PERMISSION_EDIT = 'app_permission_edit',
  GLOBAL_SETTING = 'global_setting',
  PASSWORD_POLICY = 'password_policy',
  ATTACK_PROTECTION = 'attack_protection',

  COUNTRIES = 'countries',
  COUNTRY_CREATE = 'country_create',
  COUNTRY_EDIT = 'country_edit',
  GLOBAL_APP_USERS = 'service-users',
  GLOBAL_MEMBERS = 'members',
  GLOBAL_MEMBER_CREATE = 'global_member_create',

  // FOR SERVICE USERS
  GLOBAL_SERVICE_USER_INDEX = 'global_service_user_index',
  GLOBAL_SERVICE_USER_ATTACH_APP = 'global_service_user_attach_app',
  GLOBAL_SERVICE_USER_DETAIL = 'global_service_user_detail',
  GLOBAL_SERVICE_USER_APPS_ROLES_PERMISSIONS_GROUPS = 'global_service_user_apps_roles_permissions_groups',
  GLOBAL_SERVICE_USER_DEVICES_LOGIN = 'global_service_user_devices_login',
  GLOBAL_SERVICE_USER_PASSWORD_SETTING = 'global_service_user_password_setting',
  GLOBAL_SERVICE_USER_MFA = 'global_service_user_mfa',
  GLOBAL_SERVICE_USER_SMS_OTP = 'global_service_sms_otp',
  GLOBAL_SERVICE_USER_ATTACK_PROTECTION = 'global_service_user_attack_protection',

  // FOR DASHBOARD USERS
  GLOBAL_MEMBER_ATTACH_APP = 'global_member_attach_app',
  GLOBAL_MEMBER_INDEX = 'global_member_index',
  GLOBAL_MEMBER_ACCESS_APPS = 'global_member_access_apps',
  GLOBAL_MEMBER_DETAIL = 'global_member_detail',
  GLOBAL_MEMBER_PASSWORD_SETTING = 'global_member_password_setting'
}

export const {
  summaryState,
  routeState,
  watchRouteState,
  watchSummaryState,
  on,
  onOneOf,
  redirect,
  getDetail,
  update,
  getCurrentDetail,
  onRouteMatch
} = new CreateHistory({
  URLPattern,
  routes: {
    [ROUTE_NAMES.INDEX]: {
      pathname: '/',
      meta: {
        title: ''
      }
    },
    [ROUTE_NAMES.TENANT_STATISTICS]: {
      pathname: '/:tenantId/statistics',
      meta: {
        title: 'Statistics'
      }
    },
    [ROUTE_NAMES.APPS]: {
      pathname: '/:tenantId/apps',
      meta: {
        title: 'Applications'
      }
    },
    [ROUTE_NAMES.CREATE_APP]: {
      pathname: '/:tenantId/apps/create',
      meta: {
        title: 'Create Application'
      }
    },
    [ROUTE_NAMES.APP_HOME]: {
      pathname: '/:tenantId/apps/:appId/home',
      meta: {
        title: 'Home'
      }
    },
    [ROUTE_NAMES.APP_BASIC_SETTING]: {
      pathname: '/:tenantId/apps/:appId/basic-setting',
      meta: {
        title: 'Basic Setting'
      }
    },
    [ROUTE_NAMES.APP_ADVANCED_SETTING]: {
      pathname: '/:tenantId/apps/:appId/advance-setting',
      meta: {
        title: 'Advance Setting'
      }
    },
    [ROUTE_NAMES.APP_WEBHOOK_SETTING]: {
      pathname: '/:tenantId/apps/:appId/webhooks',
      meta: {
        title: 'Webhook Setting'
      }
    },
    [ROUTE_NAMES.APP_LAUNCHPAD_SETTING]: {
      pathname: '/:tenantId/apps/:appId/launchpad-setting',
      meta: {
        title: 'Launchpad Setting'
      }
    },
    [ROUTE_NAMES.APP_GROUPS]: {
      pathname: '/:tenantId/apps/:appId/groups',
      meta: {
        title: 'Groups'
      }
    },
    [ROUTE_NAMES.APP_GROUP_CREATE]: {
      pathname: '/:tenantId/apps/:appId/groups/create',
      meta: {
        title: 'Create Group'
      }
    },
    [ROUTE_NAMES.APP_GROUP_DETAIL]: {
      pathname: '/:tenantId/apps/:appId/groups/:groupId',
      meta: {
        title: 'Group Detail'
      }
    },
    [ROUTE_NAMES.APP_GROUP_EDIT]: {
      pathname: '/:tenantId/apps/:appId/groups/:groupId/edit',
      meta: {
        title: 'Edit Group'
      }
    },
    [ROUTE_NAMES.APP_USERS]: {
      pathname: '/:tenantId/apps/:appId/users',
      meta: {
        title: 'Users'
      }
    },
    [ROUTE_NAMES.APP_USERS_CSV_IMPORT]: {
      pathname: '/:tenantId/apps/:appId/users/import',
      meta: {
        title: 'Import Users'
      }
    },
    [ROUTE_NAMES.APP_USER_DETAIL]: {
      pathname: '/:tenantId/apps/:appId/users/:userId',
      meta: {
        title: 'User Detail'
      }
    },
    [ROUTE_NAMES.USER_ASSIGN_ROLES]: {
      pathname: '/:tenantId/assign-roles',
      meta: {
        title: 'Assign Roles'
      }
    },
    [ROUTE_NAMES.APP_ROLES]: {
      pathname: '/:tenantId/apps/:appId/roles',
      meta: {
        title: 'Roles'
      }
    },
    [ROUTE_NAMES.APP_ROLES_CSV_IMPORT]: {
      pathname: '/:tenantId/apps/:appId/roles/import',
      meta: {
        title: 'Import Roles'
      }
    },
    [ROUTE_NAMES.APP_ROLE_CREATE]: {
      pathname: '/:tenantId/apps/:appId/roles/create',
      meta: {
        title: 'Create Role'
      }
    },
    [ROUTE_NAMES.APP_ROLE_DETAIL]: {
      pathname: '/:tenantId/apps/:appId/roles/:roleId',
      meta: {
        title: 'Role Detail'
      }
    },
    [ROUTE_NAMES.APP_ROLE_EDIT]: {
      pathname: '/:tenantId/apps/:appId/roles/:roleId/edit',
      meta: {
        title: 'Edit Role'
      }
    },
    [ROUTE_NAMES.APP_PERMISSIONS]: {
      pathname: '/:tenantId/apps/:appId/permissions',
      meta: {
        title: 'Permissions'
      }
    },
    [ROUTE_NAMES.APP_PERMISSIONS_CSV_IMPORT]: {
      pathname: '/:tenantId/apps/:appId/permissions/import',
      meta: {
        title: 'Import Permissions'
      }
    },
    [ROUTE_NAMES.APP_PERMISSION_CREATE]: {
      pathname: '/:tenantId/apps/:appId/permissions/create',
      meta: {
        title: 'Create Permission'
      }
    },
    [ROUTE_NAMES.APP_PERMISSION_DETAIL]: {
      pathname: '/:tenantId/apps/:appId/permissions/:permissionId',
      meta: {
        title: 'Permission Detail'
      }
    },
    [ROUTE_NAMES.APP_PERMISSION_EDIT]: {
      pathname: '/:tenantId/apps/:appId/permissions/:permissionId/edit',
      meta: {
        title: 'Edit Permission'
      }
    },
    [ROUTE_NAMES.GLOBAL_SETTING]: {
      pathname: '/:tenantId/global-setting',
      meta: {
        title: 'Global Setting'
      }
    },
    [ROUTE_NAMES.PASSWORD_POLICY]: {
      pathname: '/:tenantId/global-setting/password-policy',
      meta: {
        title: 'Global Setting'
      }
    },
    [ROUTE_NAMES.ATTACK_PROTECTION]: {
      pathname: '/:tenantId/global-setting/attack-protection',
      meta: {
        title: 'Attack Protection'
      }
    },
    [ROUTE_NAMES.COUNTRIES]: {
      pathname: '/:tenantId/global-setting/countries',
      meta: {
        title: 'Countries'
      }
    },
    [ROUTE_NAMES.COUNTRY_CREATE]: {
      pathname: '/:tenantId/global-setting/countries/create',
      meta: {
        title: 'Create Country'
      }
    },
    [ROUTE_NAMES.COUNTRY_EDIT]: {
      pathname: '/:tenantId/global-setting/countries/:countryId',
      meta: {
        title: 'Edit Country'
      }
    },
    [ROUTE_NAMES.GLOBAL_APP_USERS]: {
      pathname: '/:tenantId/service-users',
      meta: {
        title: 'Users'
      }
    },
    // SERVICE USERS
    [ROUTE_NAMES.GLOBAL_SERVICE_USER_ATTACH_APP]: {
      pathname: '/:tenantId/service-users/:serviceUserId/attach-app',
      meta: {
        title: 'Attach Application'
      }
    },
    [ROUTE_NAMES.GLOBAL_SERVICE_USER_INDEX]: {
      pathname: '/:tenantId/service-users/:serviceUserId'
    },
    [ROUTE_NAMES.GLOBAL_SERVICE_USER_DETAIL]: {
      pathname: '/:tenantId/service-users/:serviceUserId/detail',
      meta: {
        title: 'Detail'
      }
    },
    [ROUTE_NAMES.GLOBAL_SERVICE_USER_APPS_ROLES_PERMISSIONS_GROUPS]: {
      pathname:
        '/:tenantId/service-users/:serviceUserId/apps-roles-permission-groups',
      meta: {
        title: 'Apps, Roles, Permission, Groups'
      }
    },
    [ROUTE_NAMES.GLOBAL_SERVICE_USER_DEVICES_LOGIN]: {
      pathname: '/:tenantId/service-users/:serviceUserId/devices-login',
      meta: {
        title: 'Devices Login'
      }
    },
    [ROUTE_NAMES.GLOBAL_SERVICE_USER_PASSWORD_SETTING]: {
      pathname: '/:tenantId/service-users/:serviceUserId/password-setting',
      meta: {
        title: 'Password Setting'
      }
    },
    [ROUTE_NAMES.GLOBAL_SERVICE_USER_MFA]: {
      pathname: '/:tenantId/service-users/:serviceUserId/mfa-setting',
      meta: {
        title: '2FA Setting'
      }
    },
    [ROUTE_NAMES.GLOBAL_SERVICE_USER_SMS_OTP]: {
      pathname: '/:tenantId/service-users/:serviceUserId/sms-otp',
      meta: {
        title: 'SMS OTP'
      }
    },
    [ROUTE_NAMES.GLOBAL_SERVICE_USER_ATTACK_PROTECTION]: {
      pathname: '/:tenantId/service-users/:serviceUserId/attack-protection',
      meta: {
        title: 'Attack Protection'
      }
    },
    // DASHBOARD USER
    [ROUTE_NAMES.GLOBAL_MEMBERS]: {
      pathname: '/:tenantId/members',
      meta: {
        title: 'Members'
      }
    },
    [ROUTE_NAMES.GLOBAL_MEMBER_CREATE]: {
      pathname: '/:tenantId/members/create',
      meta: {
        title: 'Create Member'
      }
    },
    [ROUTE_NAMES.GLOBAL_MEMBER_INDEX]: {
      pathname: '/:tenantId/members/:memberId'
    },
    [ROUTE_NAMES.GLOBAL_MEMBER_ACCESS_APPS]: {
      pathname: '/:tenantId/members/:memberId/access-apps',
      meta: {
        title: 'Access Apps'
      }
    },
    [ROUTE_NAMES.GLOBAL_MEMBER_DETAIL]: {
      pathname: '/:tenantId/members/:memberId/detail',
      meta: {
        title: 'Member Detail'
      }
    },
    [ROUTE_NAMES.GLOBAL_MEMBER_ATTACH_APP]: {
      pathname: '/:tenantId/members/:memberId/attach-app',
      meta: {
        title: 'Attach Application'
      }
    },
    [ROUTE_NAMES.GLOBAL_MEMBER_PASSWORD_SETTING]: {
      pathname: '/:tenantId/members/:memberId/password-setting',
      meta: {
        title: 'Password Setting'
      }
    },
    [ROUTE_NAMES.UPDATE_PASSWORD]: {
      pathname: '/:tenantId/users/:userId/update-password',
      meta: {
        title: 'Update Password'
      }
    },
    [ROUTE_NAMES.LOGIN]: {
      pathname: '/login',
      meta: {
        title: 'Login'
      }
    }
  }
})

// Scroll to top on page navigate
watchRouteState(({ hash }) => {
  if (hash) return

  setTimeout(() => {
    self.scrollTo({ top: 0 })
  }, 300)
})

type RedirectParams = Parameters<typeof redirect>

export type RouteNames = RedirectParams[0]
export type RedirectOptions = RedirectParams[1]
